import { Box, Chip } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxesPacking } from "@fortawesome/free-solid-svg-icons";
import Button from "../../../../../components/Button";
import { BaseDialog } from "../../../../../components/modals/BaseDialog";
import { AddVolumeForm } from "./AddVolumeForm";
import { useMemo } from "react";

export function Volume({
  bipeds,
  volumes,
  setVolumes,
  newVolume,
  setNewVolume,
  openVolumesModal,
  handleOpenVolumesModal,
  handleCloseVolumesModal,
  handleRemoveVolume,
  handleRemoveItem,
  handleEditVolume,
}) {
  // Calcula dinamicamente se existe qualquer item bipado/escaneado
  const totalBipedItems = useMemo(() => {
    if (!bipeds) return 0;
    return Object.keys(bipeds).length;
  }, [bipeds]);

  const hasBipeds = totalBipedItems > 0;
  const totalVolumes = volumes?.length || 0;

  return (
    <Box
      sx={{
        display: "flex",
        my: 2,
        justifyContent: "flex-end",
        alignItems: "center",
        gap: 2,
      }}>
      {totalVolumes > 0 && (
        <Chip
          label={`${totalVolumes} ${totalVolumes === 1 ? "Volume Criado" : "Volumes Criados"}`}
          color="primary"
          variant="outlined"
          size="small"
          fontWeight="bold"
          sx={{ height: 32, fontWeight: "bold" }}
        />
      )}

      {/* Botão desabilitado nativamente se não houver nada bipado */}
      <Button
        text="Cadastrar Volumes"
        endIcon={<FontAwesomeIcon icon={faBoxesPacking} />}
        onClick={() => handleOpenVolumesModal()}
        disabled={!hasBipeds}
      />

      <BaseDialog
        open={openVolumesModal}
        onClose={handleCloseVolumesModal}
        title="Cadastrar Volumes"
        maxWidth={false}
        sx={{
          "& .MuiDialog-paper": {
            width: "80vw",
            maxWidth: "none",
            height: "auto",
            maxHeight: "90vh",
          },
        }}>
        <AddVolumeForm
          bipeds={bipeds}
          volumes={volumes}
          setVolumes={setVolumes}
          newVolume={newVolume}
          setNewVolume={setNewVolume}
          handleRemoveVolume={handleRemoveVolume}
          handleRemoveItem={handleRemoveItem}
          handleEditVolume={handleEditVolume}
        />
      </BaseDialog>
    </Box>
  );
}
